import ApiClient from '../ApiClient';

// Catálogo de tools da integração ativa da conta (espelhado do MCP).
// GET /api/v1/accounts/:account_id/integration_tools
class StudioIntegrationTools extends ApiClient {
  constructor() {
    super('integration_tools', { accountScoped: true });
  }
}

export default new StudioIntegrationTools();
